//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

import constant from '~/const';

export default {
  data() {
    return {
      groupToShow: '',
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader', 'generalProgress']),
    ...mapState('user', ['user']),
    ...mapState('userNotifications', [
      'userNotificationSettings',
      'notificationTypeList',
      'notificationTypeListP2PAY',
      'notificationServiceTypeList',
      'notificationGroupList',
      'notificationGroupListP2PAY',
      'notificationServiceTypeList',
      'notificationServiceTypeListP2PAY',
    ]),

    notificationGroupMenuList() {
      const {
        notificationGroupList,
        notificationGroupListP2PAY,
      } = this;

      const restGroups = this.$utils.getAppType() === 'p2pay' ? notificationGroupListP2PAY : notificationGroupList;

      return [
        {
          group: '',
          caption: 'Show all',
        },
        ...restGroups,
      ];
    },

    serviceTypes() {
      const { notificationServiceTypeList, notificationServiceTypeListP2PAY } = this;
      return this.$utils.getAppType() === 'p2pay' ? notificationServiceTypeListP2PAY : notificationServiceTypeList;
    },

    notificationGroupListFiltered() {
      const {
        notificationGroupList,
        notificationGroupListP2PAY,
        groupToShow,
      } = this;
      const toBeFiltered = this.$utils.getAppType() === 'p2pay' ? notificationGroupListP2PAY : notificationGroupList;

      if (!groupToShow) {
        return toBeFiltered;
      }

      return toBeFiltered.filter((e) => e.group === groupToShow);
    },
  },

  async mounted() {
    this.setGeneralLoader(true);
    await this.getUserNotificationSettings();
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader', 'setGeneralProgress', 'setSuccessNotification']),
    ...mapActions('userNotifications', [
      'getUserNotificationSettings',
      'updateUserNotificationsSettings',
      'setUserNotificationSettings',
      'updateUserEmailBodyType',
    ]),

    getNotificationsByGroup(group) {
      const {
        notificationTypeList,
        notificationTypeListP2PAY,
        notificationGroupList,
        notificationGroupListP2PAY,
      } = this;

      const groupWithIds = this.$utils.getAppType() === 'p2pay' ? notificationGroupListP2PAY : notificationGroupList;
      const types = this.$utils.getAppType() === 'p2pay' ? notificationTypeListP2PAY : notificationTypeList;

      const { notificationIds } = groupWithIds.find((e) => e.group === group);
      return types.filter((e) => notificationIds.includes(e.id));
    },

    getNotificationValue(notificationType, serviceType) {
      const { userNotificationSettings } = this;
      const p2pay = this.$utils.getAppType() === 'p2pay';

      return userNotificationSettings.find((e) => {
        if (p2pay) return e.notificationType === notificationType && e.notificationServiceType === serviceType;
        return e.notification === notificationType && e.notificationServiceType === serviceType;
      });
    },

    getNotificationIgnored(notificationType, serviceType) {
      const notification = this.getNotificationValue(notificationType, serviceType);
      const p2pay = this.$utils.getAppType() === 'p2pay';

      if (notification) {
        if (p2pay) {
          return !notification.notificationTypeEnabled;
        }
        return notification.ignored;
      }

      return true;
    },

    getNotificationAllowed(notificationType, serviceType) {
      const notification = this.getNotificationValue(notificationType, serviceType);
      const p2pay = this.$utils.getAppType() === 'p2pay';

      if (notification) {
        if (p2pay) return !notification.notificationTypeForcefullyEnabled;
        return notification.allowed;
      }
      return false;
    },

    async setNotification(notificationType, serviceType, value) {
      const { userNotificationSettings } = this;
      const p2pay = this.$utils.getAppType() === 'p2pay';
      let notification = null;

      if (p2pay) {
        notification = userNotificationSettings.find((e) => (
          e.notificationType === notificationType && e.notificationServiceType === serviceType
        ));
        notification.notificationTypeEnabled = value;
      } else {
        notification = userNotificationSettings.find((e) => (
          e.notification === notificationType && e.notificationServiceType === serviceType
        ));
        notification.ignored = !value;
      }
      await this.setUserNotificationSettings(userNotificationSettings);
      this.applyUserNotificationSettings();
    },

    async applyUserNotificationSettings() {
      this.setGeneralProgress(true);
      await this.updateUserNotificationsSettings();
      this.setGeneralProgress(false);
    },

    isSelectAllServices(notificationType) {
      const { userNotificationSettings } = this;
      const current = userNotificationSettings
        .filter((e) => e.notification === notificationType && e.allowed);
      if (!current.length) {
        return false;
      }
      return current.every((e) => !e.ignored);
    },

    async selectAllServices(notificationType, value) {
      const { userNotificationSettings } = this;
      const p2pay = this.$utils.getAppType() === 'p2pay';

      userNotificationSettings.forEach((e) => {
        if (p2pay) {
          if (e.notificationType === notificationType && !e.notificationTypeForcefullyEnabled) {
            e.notificationTypeEnabled = value;
          }
        }

        if (e.notification === notificationType && e.allowed) {
          e.ignored = !value;
        }
      });
      await this.setUserNotificationSettings(userNotificationSettings);
      this.applyUserNotificationSettings();
    },

    isSelectAllNotifications(group, serviceType) {
      const { userNotificationSettings } = this;
      const {
        notificationGroupList,
        notificationGroupListP2PAY,
      } = this;

      const p2pay = this.$utils.getAppType() === 'p2pay';

      const groupWithIds = p2pay ? notificationGroupListP2PAY : notificationGroupList;

      const { notificationIds } = groupWithIds.find((e) => e.group === group);

      const current = userNotificationSettings
        .filter((e) => {
          if (p2pay) {
            return notificationIds.includes(e.notification)
            && e.notificationServiceType === serviceType
            && e.notificationTypeForcefullyEnabled;
          }

          return notificationIds.includes(e.notification)
          && e.notificationServiceType === serviceType
          && e.allowed;
        });

      if (!current.length) {
        return false;
      }

      return current.every((e) => {
        if (p2pay) {
          return !e.notificationTypeEnabled;
        }
        return !e.ignored;
      });
    },

    async selectAllNotifications(group, serviceType, value) {
      const { userNotificationSettings } = this;
      const {
        notificationGroupList,
        notificationGroupListP2PAY,
      } = this;

      const p2pay = this.$utils.getAppType() === 'p2pay';

      const groupWithIds = p2pay ? notificationGroupListP2PAY : notificationGroupList;

      const { notificationIds } = groupWithIds.find((e) => e.group === group);
      userNotificationSettings.forEach((e) => {
        if (p2pay) {
          if (
            notificationIds.includes(e.notificationType)
            && e.notificationServiceType === serviceType
            && !e.notificationTypeForcefullyEnabled
          ) {
            e.notificationTypeEnabled = value;
          }
        }

        if (
          notificationIds.includes(e.notification)
          && e.notificationServiceType === serviceType
          && e.allowed
        ) {
          e.ignored = !value;
        }
      });
      await this.setUserNotificationSettings(userNotificationSettings);
      this.applyUserNotificationSettings();
    },

    isSelectGroup(group) {
      const { userNotificationSettings } = this;
      const {
        notificationGroupList,
        notificationGroupListP2PAY,
      } = this;

      const p2pay = this.$utils.getAppType() === 'p2pay';

      const groupWithIds = p2pay ? notificationGroupListP2PAY : notificationGroupList;

      const { notificationIds } = groupWithIds.find((e) => e.group === group);
      const current = userNotificationSettings.filter((e) => {
        if (p2pay) {
          return notificationIds.includes(e.notification) && e.notificationTypeEnabled;
        }
        return notificationIds.includes(e.notification) && e.allowed;
      });
      if (!current.length) {
        return false;
      }
      return current.every((e) => !e.ignored);
    },

    async selectGroup(group, value) {
      const { userNotificationSettings } = this;
      const {
        notificationGroupList,
        notificationGroupListP2PAY,
      } = this;

      const p2pay = this.$utils.getAppType() === 'p2pay';

      const groupWithIds = p2pay ? notificationGroupListP2PAY : notificationGroupList;

      const { notificationIds } = groupWithIds.find((e) => e.group === group);
      userNotificationSettings.forEach((e) => {
        if (p2pay) {
          if (
            notificationIds.includes(e.notificationType)
            && !e.notificationTypeForcefullyEnabled
          ) {
            e.notificationTypeEnabled = value;
          }
        }

        if (
          notificationIds.includes(e.notification)
          && e.allowed
        ) {
          e.ignored = !value;
        }
      });
      await this.setUserNotificationSettings(userNotificationSettings);
      this.applyUserNotificationSettings();
    },

    filterGroup(group) {
      this.groupToShow = group;
    },

    async updateBodyType(value) {
      const { id } = this.user;
      this.setGeneralLoader(true);
      await this.updateUserEmailBodyType({
        userId: id,
        emailBodyType: value,
      });
      this.setGeneralLoader(false);
      this.setSuccessNotification('Email body type updated');
    },
  },
};
